import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import AddCircle from '@material-ui/icons/AddCircle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

interface ICornerScrewsProps {
  noOfScrews?: any;
}

const CornerScrews: React.FunctionComponent<ICornerScrewsProps> = ({
  noOfScrews = 2,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {Array.from({ length: noOfScrews }, (item, index) => index).map(
        (key: Number) => {
          return (
            <AddCircle
              key={key + ''}
              htmlColor="darkgoldenrod"
              fontSize="small"
            />
          );
        }
      )}
    </div>
  );
};

export default CornerScrews;
